import gql from 'graphql-tag';

const ME_QUERY = gql`
  query Me {
    me {
      _id
      name
      roles
      emails {
        address
        verified
      }
      user_role
      profile {
        name
        region
        profession
        imageUrl
      }
      username
      updatedAt
      createdAt
      customer
      countryCode
    }
  }
`;

export default ME_QUERY;
